
export const URL_AUTHENTICATION = '/api/username/login/';
export const URL_LOGOUT = '/api/v1/user-logout';
